<template>
    <Breadcrumb :items="breadcrumbs" />
    <div class="container-fluid my-3">
        <div class="filter my-3">
            <div class="filter-head">
                <h4>حجوزات ثالثة إعدادي ({{ paggination }})</h4>
                <div class="buttons">
                    <BulkSms v-if="gradeId" :academic_year_id="gradeId" />
                    <!-- <WhatsAppGroupSend /> -->
                    <!-- <router-link to="/whatsapp_groups" class="btn PrimaryButton">
                      <i class="pi pi-users me-1"></i>مجموعات واتساب
                    </router-link> -->
                    <router-link to="/attendance/3" class="btn PrimaryButton">الغياب</router-link>
                    <router-link to="/absence/3" class="btn PrimaryButton">شيت الدفع</router-link>
                    <router-link to="/reservation/add" class="btn PrimaryButton">إضافة حجز</router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-12 col-12">
                    <div class="form-group">
                        <label for="search">ابحث</label>
                        <input type="search" id="search" class="form-control" placeholder="ابحث" v-model="word"
                            @keyup="debounceFetchReservation">
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                  <div class="d-flex form-group flex-column">
                    <label for="degree">الدرجة</label>
                    <div class="d-flex gap-1">
                      <input type="text" id="min_degree" class="form-control" placeholder="Min" v-model="min_degree"
                             @keyup="fetchReservation">
                      <input type="text" id="max_degree" class="form-control" placeholder="Max" v-model="max_degree"
                             @keyup="fetchReservation">
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label for="status">حالة الحجز</label>
                        <Dropdown v-model="status" :options="status_list" showClear optionLabel="title"
                            placeholder="حالة الحجز" @change="fetchReservation" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label for="gender">الجنس</label>
                        <Dropdown v-model="gender" :options="gender_list" showClear optionLabel="title"
                            placeholder="الجنس" @change="fetchReservation" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-3 col-12">
                    <div class="d-flex">
                        <div class="form-group d-flex flex-column mx-1">
                            <label for="" class="non_opacity">طباعة</label>
                            <button class="btn btn-success px-3" @click="exportToExcel">
                                <i class="pi pi-file-excel"></i>
                            </button>
                        </div>
                        <div class="form-group d-flex flex-column mx-1">
                            <label for="" class="non_opacity">طباعة</label>
                            <button class="btn btn-danger px-3" v-print="'#reservationTable'">
                                <i class="pi pi-file-pdf"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row reservation-table">
          <div id="reservationTable" class="a4">
            <div class="first-screen-pdf">
              <h1>كشوفات طلاب</h1>
              <h2>الصف الثالث الاعدادي</h2>
              <h3>{{ gender?.id === 1 ? "بنين" : gender?.id === 2 ? "بنات" : "" }} ( {{ paggination }} )</h3>
            </div>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">رقم</th>
                        <th scope="col">
                            <span @click="sortByName" class="btn d-flex align-items-center fw-bold gap-2 p-0 m-0">
                                الاسم
                                <i :class="sortAsc ? 'pi pi-sort-alpha-down' : 'pi pi-sort-alpha-up'"></i>
                            </span>
                        </th>
                        <th scope="col">
                            <span @click="sortByDegree" class="btn d-flex align-items-center fw-bold gap-2 p-0 m-0">
                                الدرجة
                                <i :class="sortDegree ? 'pi pi-sort-numeric-down' : 'pi pi-sort-numeric-down-alt'"></i>
                            </span>
                        </th>
                        <th scope="col">رقم الطالب</th>
                        <th scope="col">رقم ولي الامر</th>
                        <th scope="col">الجنس</th>
                        <th scope="col">التعليم</th>
                        <th scope="col">العنوان</th>
                        <th scope="col">الشهادة</th>
                        <th scope="col">حالة الحجز</th>
                        <th scope="col">الحالة</th>
                        <th scope="col">التحكم</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(reservation, index) in reservations.data" :key="index">
                        <td data-label="ID">{{ index + 1 }}</td>
                        <td data-label="الاسم">{{ reservation.name }}</td>
                        <td data-label="الدرجة">{{ reservation.math_degree }}</td>
                        <td data-label="رقم الطالب">{{ reservation.student_phone }}</td>
                        <td data-label="رقم ولي الامر">{{ reservation.parent_phone }}</td>
                        <td data-label="الجنس">{{ reservation.gender == 1 ? "ولد" : "بنت" }}</td>
                        <td data-label="التعليم">{{ reservation.education_type == 1 ? "عام" : reservation.education_type == 2 ? "أزهر" : "" }}</td>
                        <td data-label="العنوان">
                          <span
                              :tooltip="reservation.address"
                              flow="up"
                          >{{ reservation.address.slice(0, 10) }}</span>
                        </td>
                        <td data-label="الشهادة"><Button label="الشهادة"
                                @click="openImageCertificate(reservation.certificate_image)" /></td>
                        <td data-label="حالة الحجز">
                          <template v-if="reservation.block === 0">
                            <span v-if="reservation.status == 0" class="status-badge status-badge--pending">الحجز معلق</span>
                            <span v-else-if="reservation.status == 1" class="status-badge status-badge--accepted">الحجز مقبول</span>
                            <span v-else-if="reservation.status == 2" class="status-badge status-badge--rejected">الحجز مرفوض</span>
                            <span v-else-if="reservation.status == 3" class="status-badge status-badge--waiting">في انتظار الشهادة</span>
                          </template>
                          <span v-else class="status-badge status-badge--blocked">محظور</span>
                        </td>
                        <td data-label="الحالة">
                          <button class="btn btn-success mx-1" type="button"
                                  v-if="reservation.status != 1"
                                  :tooltip="'قبول الحجز'"
                                  flow="up"
                                  @click="changeReservationStatus(reservation.id, 1, index)">
                            <i class="pi pi-check-circle"></i>
                          </button>

                          <button class="btn btn-danger mx-1"
                                  type="button" v-if="reservation.status != 2"
                                  :tooltip="'رفض الحجز'"
                                  flow="up"
                                  @click="changeReservationStatus(reservation.id, 2, index)">
                            <i class="pi pi-ban"></i>
                          </button>

                          <button class="btn btn-warning text-white mx-1"
                                  type="button"
                                  v-if="reservation.status != 0"
                                  :tooltip="'تعليق الحجز'"
                                  flow="up"
                                  @click="changeReservationStatus(reservation.id, 0, index)">
                            <i class="pi pi-exclamation-circle"></i>
                          </button>

                          <button class="btn btn-info text-white mx-1"
                                  type="button"
                                  v-if="reservation.status != 3"
                                  :tooltip="'في انتظار الشهادة'"
                                  flow="up"
                                  @click="changeReservationStatus(reservation.id, 3, index)">
                            <i class="pi pi-images"></i>
                          </button>
                        </td>
                        <td data-label="التحكم">
                          <router-link class="btn btn-info text-white mx-1"
                                       :tooltip="'تعديل كلمة المرور'"
                                       flow="up"
                                       :to="`/update_password/${reservation.user_id}`">
                            <i class="pi pi-unlock"></i>
                          </router-link>
                          <router-link class="btn btn-primary text-white mx-1"
                             :tooltip="'تعديل الحجز'"
                             flow="up"
                             :to="`/user/edit/${reservation.user_id}`">
                              <i class="pi pi-pencil"></i>
                          </router-link>
                          <button :class="`btn ${reservation.block === 0 ? 'btn-danger': 'btn-success'} text-white mx-1`"
                                  type="button"
                                  :tooltip="`${reservation.block === 1 ? 'الغاء حظر الطالب' : 'حظر الطالب'}`"
                                  flow="up"
                                  @click="blockReservation(reservation.user_id)">
                            <i :class="`pi ${reservation.block === 0 ? 'pi-ban' : 'pi-circle'}`"></i>
                          </button>
                          <button class="btn btn-danger text-white mx-1"
                                  type="button"
                                  :tooltip="'حذف الحجز'"
                                  flow="up"
                                  @click="deleteReservation(reservation.id)">
                            <i class="pi pi-trash"></i>
                          </button>
                        </td>
                    </tr>
                    <!-- Add empty rows if needed -->
                    <tr v-for="n in extraRows" :key="'empty-' + n" class="empty-row">
                      <td>{{ reservations.data.length + n }}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                </tbody>
            </table>
          </div>
        </div>
        <div class="row">
            <div class="col-md-10 col-12">
                <pagination :data="reservations"
                    class="mx-auto d-flex align-items-center justify-content-center pagination"
                    @pagination-change-page="fetchReservation">
                    <template v-slot:prev-nav>&lt;</template>
                    <template v-slot:next-nav>&gt;</template>
                </pagination>
            </div>
            <div class="col-md-2 col-12 mt-md-0 mt-3">
                <div class="form-group d-flex md-justify-content-end justify-content-center">
                    <Dropdown v-model="per_page" :options="per_pages" showClear optionLabel="title"
                        placeholder="عدد الطلاب" @change="fetchReservation" />
                </div>
            </div>
        </div>
    </div>

    <Dialog v-model:visible="visible" :dismissableMask="true" modal header="صورة الشهادة">
        <Image :src="certificate_image" alt="certificate_image" class="certificate_image" preview />
        <!-- <img :src="certificate_image" class="certificate_image" alt="certificate_image"> -->
    </Dialog>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import pagination from "laravel-vue-pagination";
import * as XLSX from "xlsx/xlsx.mjs";
import Image from 'primevue/image';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import BulkSms from "@/components/reservation/BulkSms.vue";
import WhatsAppGroupSend from "@/components/reservation/WhatsAppGroupSend.vue";
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
    name: "reservation-page",
    data() {
        return {
            reservations: {
                data: [],
            },
            certificate_image: "",
            visible: false,
            word: "",
            status: null,
            min_degree: 0,
            max_degree: "",
            gender: "",
            status_list: [
                {
                    id: 0,
                    title: "معلق",
                },
                {
                    id: 1,
                    title: "مقبول",
                },
                {
                    id: 2,
                    title: "مرفوض",
                },
                {
                  id: 6,
                  title: "محظور",
                },
                {
                    id: 3,
                    title: "في انتظار الشهادة",
                }
            ],
            gender_list: [
                {
                    id: 1,
                    title: "ولد",
                },
                {
                    id: 2,
                    title: "بنت",
                },
            ],
            per_pages: [
                {
                    title: "الكل",
                    id: 10000,
                },
                {
                    title: 10,
                    id: 10,
                },
                {
                    title: 25,
                    id: 25,
                },
                {
                    title: 50,
                    id: 50,
                },
                {
                    title: 100,
                    id: 100,
                },
            ],
            per_page: null,
            paggination: "",
            sortAsc: true,
            sortDegree: true,
            orderByName: true,
            orderByDegree: false,
            searchTimeout: null,
            breadcrumbs: [
                { name: 'الرئيسية', path: '/' },
                { name: 'حجز ثالثة إعدادي', path: '/reservation' },
            ]
        }
    },
    components: {
        Dialog,
        Button,
        Dropdown,
        pagination,
        Image,
        Breadcrumb,
        BulkSms,
        WhatsAppGroupSend
    },
    computed: {
      gradeStore() { return useGradeStore(); },
      gradeId() {
        const grade = this.gradeStore.allGrades.find(g => g.education_level_legacy == 3)
            || this.gradeStore.activeGrades.find(g => g.education_level_legacy == 3);
        return grade?.id ?? null;
      },
      extraRows() {
        return 29 - (Number(this.paggination) % 29);
      }
    },
    methods: {
        debounceFetchReservation() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.fetchReservation();
            }, 1500); // يمكنك تغيير المدة حسب الحاجة
        },
      fetchReservation(page = 1) {
        const formData = new FormData();
        if (this.gradeId) formData.append('academic_year_id', this.gradeId);

        if (this.word) {
          formData.append('word', this.word);
        }
        if (this.status?.id !== 6 && this.status !== null) {
          formData.append('status', this.status.id);
        }
        if (this.status?.id === 6) {
          formData.append('is_block', 1);
        }
        if (this.min_degree) {
          formData.append('min_degree', this.min_degree);
        }
        if (this.max_degree) {
          formData.append('max_degree', this.max_degree);
        }
        if (this.gender) {
          formData.append('gender', this.gender.id);
        }
        if (this.orderByName) {
          formData.append('order_by_name', this.orderByName ? 1 : 0);
        }
        if (this.orderByDegree) {
          formData.append('order_by_degree', this.orderByDegree ? 1 : 0);
        }

        axios.defaults.headers.common["per_page"] = this.per_page == null ? 10 : this.per_page.id;
        axios
            .post(`/all_reservations?page=${page}`, formData)
            .then((response) => {
              this.reservations = response.data.data;
              this.paggination = response.data.data.meta.total;
            })
            .catch((error) => {
              this.reservations = {};
            });
      },
      changeReservationStatus(reservation_id, status, index) {
        const statusLabels = {
          0: "تعليق الحجز",
          1: "الموافقة على الحجز",
          2: "رفض الحجز",
          3: "في انتظار الشهادة"
        };

        const formData = new FormData();
        formData.append('reservation_id', reservation_id);
        formData.append('status', status);

        Swal.fire({
          title: ` هل تريد التحويل الى ${statusLabels[status]}؟`,
          text: ` سيتم التحويل ${statusLabels[status]}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "رجوع",
          confirmButtonText: statusLabels[status],
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post(`/change_reservation_status`, formData).then(({ data }) => {
              if (data.status == true) {
                Swal.fire("", data.message, "success");
                this.reservations.data[index].status = status;
              } else {
                Swal.fire("", data.message, "error");
              }
              return data;
            });
          }
        });
      },
      deleteReservation(reservation_id) {
            const formData = new FormData();
            formData.append('reservation_id', reservation_id);
            Swal.fire({
                title: "هل تريد حذف الحجز؟",
                text: "سيتم حذف الحجز نهائيا",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "رجوع",
                confirmButtonText: "حذف الحجز",
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .post(`delete_reservation`, formData)
                        .then(({ data }) => {
                            if (data.status == true) {
                                Swal.fire("", data.message, "success");
                                this.reservations.data = this.reservations.data.filter(r => r.id !== reservation_id);
                            } else {
                                Swal.fire("", data.message, "error");
                            }
                        });
                }
            });
        },
      blockReservation(user_id) {
        const formData = new FormData();
        formData.append('user_id', user_id);
        Swal.fire({
          title: "هل تريد حظر الطالب؟",
          text: "سيتم حظر الطالب نهائيا",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "رجوع",
          confirmButtonText: "حظر الطالب",
        }).then((result) => {
          if (result.isConfirmed) {
            axios
                .post(`toggle_block_user`, formData)
                .then(({data}) => {
                  if (data.status == true) {
                    Swal.fire("", data.message, "success");

                    const reservation = this.reservations.data.find(r => r.user_id === user_id);
                    if (reservation) {
                      reservation.block = reservation.block === 0 ? 1 : 0;
                    }
                  } else {
                    Swal.fire("", data.message, "error");
                  }
                });
          }
        });
      },

        openImageCertificate(certificate_image) {
            this.certificate_image = certificate_image;
            this.visible = true
        },

        sortByName() {
            this.orderByName = !this.orderByName;
            this.sortAsc = !this.sortAsc;
            this.orderByDegree = false;
            this.sortDegree = true;
            this.fetchReservation()
        },
        sortByDegree() {
            this.orderByDegree = !this.orderByDegree;
            this.sortDegree = !this.sortDegree;
            this.orderByName = false;
            this.sortAsc = true;
            this.fetchReservation()
        },

        exportToExcel() {
            this.loading = true;
            // Clone the table
            const table = document.getElementById("reservationTable").cloneNode(true);

            // Remove "صورة الشهادة" and "حالة الحجز" columns from thead
            const thead = table.querySelector("thead tr");
            if (thead) {
                // Find indexes of the columns to remove
                const headers = Array.from(thead.children);
                const removeIndexes = [];
                headers.forEach((th, idx) => {
                    if (
                        th.textContent.trim() === "الشهادة" ||
                        th.textContent.trim() === "حالة الحجز" ||
                        th.textContent.trim() === "رقم الطالب" ||
                        th.textContent.trim() === "الجنس" ||
                        th.textContent.trim() === "العنوان" ||
                        th.textContent.trim() === "التحكم"
                    ) {
                        removeIndexes.push(idx);
                    }
                });
                // Remove from last to first to avoid index shift
                removeIndexes.sort((a, b) => b - a).forEach(idx => thead.removeChild(headers[idx]));

                // Remove corresponding td in each row
                const rows = table.querySelectorAll("tbody tr");
                rows.forEach(row => {
                    removeIndexes.forEach(idx => {
                        if (row.children[idx]) row.removeChild(row.children[idx]);
                    });
                });
            }

            // Convert the modified table to a worksheet
            const ws = XLSX.utils.table_to_sheet(table);
            // Create a workbook with a single sheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            // Save the workbook as an Excel file
            XLSX.writeFile(wb, "reservations.xlsx");
        },
    },
    async mounted() {
        if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
        if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
        this.fetchReservation();
    },
}
</script>

<style scoped>
@media print {
  th:nth-child(6),
  td:nth-child(6),
  th:nth-child(8),
  td:nth-child(8),
  th:nth-child(9),
  td:nth-child(9),
  th:nth-child(10),
  td:nth-child(10),
  th:nth-child(11),
  td:nth-child(11),
  th:nth-child(12),
  td:nth-child(12){
    display: none !important;
  }
}

.empty-row {
  display: none;
}
@media print {
  .empty-row {
    display: table-row !important;
  }
}
</style>